export const BLIP_EVENTS = [
    {
        name: 'BlipWidget.saque.conhecimentoSuporte',
        event: new CustomEvent('BlipWidget.event', { 'detail': 'conhecimentoSuporte' })
    },
    {
        name: 'BlipWidget.saque.dificuldadesTecnicas',
        event: new CustomEvent('BlipWidget.event', { 'detail': 'dificuldadesTecnicas' })
    },
    {
        name: 'BlipWidget.saque.custosAltos',
        event: new CustomEvent('BlipWidget.event', { 'detail': 'custosAltos' })
    },
    {
        name: 'BlipWidget.saque.tivePerdas',
        event: new CustomEvent('BlipWidget.event', { 'detail': 'tivePerdas' })
    },
];